import e from"./spacer";export{StyledSpacer}from"./spacer.styles";export default e;